/**
 * name of the operation (M) that the user has to have access to
 * in order to be able to work with external deliveries
 */
export const EXTERNAL_DELIVERY_OPERATION = `createExternalDelivery`
